/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { extract } from '@app/core';
import { CampaignCreateComponent } from '@app/campaign/campaign-create/campaign-create.component';
import { CampaignListComponent } from '@app/campaign/campaign-list/campaign-list.component';
import { CampaignViewsComponent } from '@app/campaign/campaign-views/campaign-views.component';
import { MenuService } from '@app/core/menu/menu.service';

const routes: Routes = [
  Shell.childRoutes([
    { path: '', redirectTo: '/campaign/create', pathMatch: 'full' },
    { path: 'campaign/create', component: CampaignCreateComponent, data: { title: extract('Campaign') } },
    { path: 'campaigns', component: CampaignListComponent, data: { title: extract('Campaign') } },
    { path: 'campaign/view', component: CampaignViewsComponent, data: { title: extract('Campaign') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [MenuService],
})
export class CampaignRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'campaign',
        title: 'Campaign',
        icon: 'fal fa-feather',
      })
      .addItem({
        key: 'campaign.create',
        path: '/campaign/create',
        requiredPermission: 'campaign.create',
        title: 'New Campaign',
      })
      .addItem({
        key: 'campaign.list',
        path: '/campaigns',
        requiredPermission: 'campaign.create',
        title: 'Campaigns',
      });
  }
}
